<style lang="less">
    .texture-panel {
        .chosenItem {
            border-color: var(--themeColor);
        }
        .text-preview {
        }
        .text-downs {
            width: 206px !important;
            display: flex;
            flex-wrap: wrap;
            padding: 3px;
            border-radius: 3px;
        }
        .text-down {
            margin: 3px;
            width: 40px !important;
            height: 40px !important;
        }
        .texture-item {
            margin-top: 6px;
            display: flex;
            justify-content: space-between;
        }
        .texture-insBtn {
            padding: 0 6px;
            height: 26px;
            text-align: center;
            color: white;
            line-height: 26px;
            border-radius: 3px;
            cursor: pointer;
            background-color: var(--themeColor);
        }
        .ivu-checkbox-wrapper {
            white-space: nowrap;
        }
    }
</style>

<template>
    <div class="texture-panel">
        <div class="rPanel-item">
            <span class="left">{{ $t("Texture") }}</span>
            <div class="item-dropbox" v-click-outside="closeText" @click="toggleText" style="width: 80px">
                <div class="item-preview text-preview" :style="itemPreview" style="border-right-width: 20px"></div>
                <Icon class="ios-arrow" type="ios-arrow-down" />
                <div class="item-downs text-downs" v-show="showText">
                    <div
                        class="item-down text-down"
                        v-for="(item, index) in textImgs"
                        :key="index"
                        :class="{ chosenItem: activeTextureIdx === index }"
                        :style="textCss(index)"
                        @click.stop="setTexture(index)"
                    ></div>
                </div>
            </div>
        </div>
        <ColorSet :from="fmtType.fill" :fromPaintType="4" @changeSet="handleChangeSet" />
        <div class="rPanel-item texture-item">
            <span>{{ $t("InsPic") }}</span>
            <label class="texture-insBtn" for="texture-img">{{ $t("choosePic") }}</label>
            <input style="display: none" type="file" id="texture-img" accept="image/png,image/jpeg" @change="insertTextImg" />
            <Checkbox v-model="textureFit" @on-change="toggleTextFit">{{ $t("fit") }}</Checkbox>
        </div>
    </div>
</template>

<script lang="ts">
    declare var Const: any;
    declare var EDDocument: any;
    declare var eFmtSetFlag: any;
    import { Component, Prop, Vue } from "vue-property-decorator";
    import ColorSet from "./ColorSet.vue";
    @Component({
        components: {
            ColorSet,
        },
    })
    export default class Texture extends Vue {
        loadEnd = false;
        showText: boolean = false;

        get textureFit() {
            return this.$store.state.shape.fillFmt.textureFit;
        }
        set textureFit(v) {
            this.$store.commit("setFillFmtData", {
                type: "textureFit",
                data: v,
            });
        }
        closeText() {
            this.showText = false;
        }
        toggleText() {
            this.showText = !this.showText;
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get activeTextureIdx() {
            return this.$store.state.shape.fillFmt.textureIndex;
        }
        set activeTextureIdx(v) {
            this.$store.commit("setFillFmtData", {
                type: "textureIndex",
                data: v,
            });
        }
        get textImgs() {
            return this.$store.state.ui.textureImgUrl;
        }
        get previewSrc() {
            return this.$store.state.shape.fillFmt.textureSrc;
        }
        get itemPreview() {
            return {
                background: `url(${this.previewSrc}) content-box`,
            };
        }
        get textureLoadedStatus() {
            return this.$store.state.ui.textureLoadedStatus;
        }
        set textureLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "textureLoadedStatus",
                data: v,
            });
        }
        textCss(index) {
            return {
                background: `url(${this.textImgs[index]})`,
            };
        }
        setTexture(index) {
            this.activeTextureIdx = index;
            window["_view"].setFmt(
                {
                    _index: index,
                },
                eFmtSetFlag.FillTextureIdx
            );
            this.closeText();
            this.handleChangeSet();
        }
        handleChangeSet() {
            this.$emit("changeSet");
        }
        toggleTextFit(fit) {
            console.log(fit);
            window["_view"].setFmt(
                {
                    _fit: fit,
                },
                eFmtSetFlag.FillTextureFit
            );
            this.handleChangeSet();
        }
        insertTextImg(e) {
            let file = e.target.files[0];
            if (!file) return;
            let blob = new Blob([file], { type: file.type });
            window["_view"].insertTextureImage(blob, file.name);
            this.handleChangeSet();
        }

        mounted() {}

        created() {
            console.log("texture filllllllllll");
            if (!this.textureLoadedStatus) {
                let ts = this;
                this.textureLoadedStatus = 1;
                this.$store.dispatch("loadConfig", ["texture.tar"]).then((e) => {
                    EDDocument.loadTextureData(this.$store.state.ui.textureImgUrl).then(() => {
                        this.textureLoadedStatus = 2;
                        ts.loadEnd = true;
                    });
                });
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "Texture": "纹理",
    "InsPic": "插入",
    "choosePic": "选择本地图片",
    "fit": "适应"
  },
  "en": {
    "Texture": "Texture",
    "InsPic": "Insert from",
    "choosePic": "File...",
    "fit": "Fit"
  },
  "fr": {
    "Texture": " Texture",
    "InsPic": "Insérer",
    "choosePic": "Sélectionner une image locale",
    "fit": "Adapter"
  },
  "de": {
    "Texture": "Textur",
    "InsPic": "Einfügen",
    "choosePic": "Datei",
    "fit": "Anpassen"
  },
  "jp": {
    "Texture": "テクスチャー",
    "InsPic": "挿入",
    "choosePic": "ローカルの画像を選択",
    "fit": "適応"
  },
  "es": {
    "Texture": "Textura",
    "InsPic": "Insertar desde",
    "choosePic": "Archivo",
    "fit": "Ajustar"
  },
  "pt": {
    "Texture": "Textura",
    "InsPic": "Inserir de",
    "choosePic": "Ficheiro...",
    "fit": "Ajustar"
  },
  "it": {
    "Texture": "Texture",
    "InsPic": "Inserisci da",
    "choosePic": "File...",
    "fit": "Adatta"
  },
  "tw": {
    "Texture": "紋理",
    "InsPic": "插入",
    "choosePic": "選擇本地圖片",
    "fit": "適合"
  }
}
</i18n>
